class DateUtils{

    // Idea by https://stackoverflow.com/a/5539081
    public secondsToHHMMSS(seconds:number){
        let h = Math.floor(seconds / 3600);
        let m = Math.floor(seconds % 3600 / 60);
        let s = Math.floor(seconds % 3600 % 60);

        let formattedTime = '';

        // Show only this time blocks, they are not 0
        s && (formattedTime = ('0' + s).slice(-2));
        m && (formattedTime = ('0' + m).slice(-2) + ':' + formattedTime);
        h && (formattedTime = ('0' + h).slice(-2) + ':' + formattedTime);

        return formattedTime;
    }

}

export default new DateUtils();


// WEBPACK FOOTER //
// ./src/app/utils/DateUtils.ts